<!-- Header -->
<app-patient-header [member]="member" [showHeader]="showHeader" [type]="'case'"></app-patient-header>
<app-flag-list [caseId]="id" [memberId]=""></app-flag-list>

<!-- Body -->
<kendo-splitter #splitter orientation="horizontal" style="background-color:#f5f6fb; border: none;"
  (layoutChange)="updateSplitterBar()">
  <kendo-splitter-pane>
    <kendo-tabstrip #tabstrip (tabSelect)="onTabSelect($event)">
      <kendo-tabstrip-tab title="{{ 'SUMMARY' | translate }}" [selected]="true">
        <ng-template kendoTabContent>
          <div class="content-background pl-3 pr-3 pt-0">
            <app-case-detail-summary *ngIf="member" [id]="id" [data]="model" [member]="member" #caseDetailSummary>
            </app-case-detail-summary>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
      <!--Notes-->
      <kendo-tabstrip-tab *ngIf="notesEnabled">
        <ng-template kendoTabTitle>
          <div kendoTooltip position="top" class="keyboard-accessible" tabindex="0" showOn="hover"
            style="display: inline;">
            <span [title]="tabCounts?.notes > 0 && limitNotes > 0 ? limitNotesText : ''">
              {{ 'NOTES' | translate }}
              <span *ngIf="tabCounts?.notes > 0 && limitNotes > 0" class="badge badge-pill badge-counts">{{tabCounts?.notes}}</span>
            </span>
          </div>
        </ng-template>
        <ng-template kendoTabContent>
          <div class="content-background pl-3 pr-3 pt-0">
            <div class="row mt-2">
              <div class="col-sm-12">
                <app-notes-list-section [caseId]="id" (refresh)="getCaseCountTabs()"></app-notes-list-section>
              </div>
            </div>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
      <!--Contacts-->
      <kendo-tabstrip-tab *ngIf="contactsEnabled">
        <ng-template kendoTabTitle>
          <div kendoTooltip position="top" class="keyboard-accessible" tabindex="0" showOn="hover"
            style="display: inline;">
            <span [title]="tabCounts?.contacts > 0 && limitContacts > 0 ? limitContactsText : ''">
              {{ 'CONTACT-HISTORY' | translate }}
              <span *ngIf="tabCounts?.contacts > 0 && limitContacts > 0" class="badge badge-pill badge-counts">{{tabCounts?.contacts}}</span>
            </span>
          </div>
        </ng-template>
        <ng-template kendoTabContent>
          <!-- Contact History -->
          <div class="content-background pl-3 pr-3 pt-0">
            <div class="row mt-2">
              <div class="col-sm-12">
                <app-contact-history-section *ngIf="member" [memberId]="member.id" (refresh)="getCaseCountTabs()">
                </app-contact-history-section>
              </div>
            </div>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
      <!--Appointments-->
      <kendo-tabstrip-tab *ngIf="appointmentsEnabled">
        <ng-template kendoTabTitle>
          <div kendoTooltip position="top" class="keyboard-accessible" tabindex="0" showOn="hover"
            style="display: inline;">
            <span [title]="tabCounts?.appointments > 0 && limitAppointments > 0 ? limitAppointmentsText : ''">
              {{ 'APPOINTMENTS' | translate }}
              <span *ngIf="tabCounts?.appointments > 0 && limitAppointments > 0"
                class="badge badge-pill badge-counts">{{tabCounts?.appointments}}</span>
            </span>
          </div>
        </ng-template>
        <ng-template kendoTabContent>
          <div class="content-background pl-3 pr-3 pt-0">
            <div class="row mt-2">
              <div class="col-sm-12">
                <app-appointment-list-section [memberId]="member.id" (refresh)="getCaseCountTabs()">
                </app-appointment-list-section>
              </div>
            </div>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
      <!--Events-->
      <kendo-tabstrip-tab *ngIf="eventsEnabled">
        <ng-template kendoTabTitle>
          <div kendoTooltip position="top" class="keyboard-accessible" tabindex="0" showOn="hover"
            style="display: inline;">
            <span [title]="(tabCounts?.events + tabCounts?.appointments) > 0 && limitEvents > 0 ? limitEventsText : ''">
              {{ 'EVENTS' | translate }}
              <span *ngIf="tabCounts?.events + tabCounts?.appointments > 0 && limitEvents > 0"
                class="badge badge-pill badge-counts">{{tabCounts?.events +
                tabCounts?.appointments}}</span>
            </span>
          </div>
        </ng-template>
        <ng-template kendoTabContent>
          <div class="content-background pl-3 pr-3 pt-0">
            <app-case-detail-event [model]="model" [member]="member"></app-case-detail-event>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
      <!--Case extensions-->
      <kendo-tabstrip-tab title="{{ 'EXTENSIONS' | translate }}"
        *ngIf="(caseExtensionsEnabled && viewExtensions?.gridData?.total > 0) || caseExtensionsEditable">
        <ng-template kendoTabContent>
          <div class="content-background pl-3 pr-3 pt-2">
            <kendo-grid [data]="viewExtensions.gridData" [selectable]="{ mode: 'single' }" [sortable]="true"
              [sort]="viewExtensions.state.sort" [resizable]="true" [selectable]="{mode: 'single'}"
              [kendoGridSelectBy]="'id'" (add)="caseExtensionAddHandler($event)" [navigable]="true"
              (edit)="caseExtensionEditHandler($event)" (save)="saveCaseExtension($event)"
              (cancel)="viewExtensions.cancelHandler($event)" (dataStateChange)="extensionsDataStateChange($event)">
              <kendo-grid-messages noRecords="{{ 'NO-CASE-EXTENSIONS' | translate }}">
              </kendo-grid-messages>
              <!--Organization Name -->
              <kendo-grid-column field="settingExtension.organization.name"
                title="{{ 'SOURCE-ORGANIZATION' | translate }}" [width]="50" [filterable]="false" [sortable]="true">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <span
                    *ngIf="dataItem.settingExtension.organization">{{dataItem.settingExtension.organization.name}}</span>
                </ng-template>
                <ng-template kendoGridEditTemplate>
                  <div [formGroup]="caseExtensionFormGroup">
                    <kendo-combobox id="organization" formControlName="organization" [data]="organizations"
                      [textField]="'name'" [valueField]="'id'" (valueChange)="organizationChange(true)"
                      [readonly]="!isOperatorRole">
                      <ng-template kendoComboBoxItemTemplate let-dataItem>
                        <span
                          [ngClass]="{'font-weight-bold': isOrganizationHasExtension(dataItem.id)}">{{dataItem.name}}</span>
                      </ng-template>
                    </kendo-combobox>
                  </div>
                </ng-template>
              </kendo-grid-column>
              <!--Extension Name-->
              <kendo-grid-column field="settingExtension.name" [width]="50" title="{{ 'NAME' | translate }}"
                [filterable]="false" [sortable]="true">
                <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-formGroup="caseExtensionFormGroup">
                  <kendo-dropdownlist [data]="extensionsByCategoryAndOrganizationUnused" textField="name"
                    valueField="id" [valuePrimitive]="false"
                    [formControl]="caseExtensionFormGroup.get('settingExtension')">
                  </kendo-dropdownlist>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                  <span title="{{dataItem.displayLabel}}"
                    *ngIf="dataItem.settingExtension">{{dataItem.settingExtension.name}}
                  </span>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="value" [width]="40" title="{{ 'VALUE' | translate }}">
                <ng-template kendoGridEditTemplate>
                  <div [formGroup]="caseExtensionFormGroup">
                    <input kendoTextBox formControlName="value" maxlength="10485760" />
                  </div>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                  <span *ngIf="dataItem.value">{{formatExtensionValue(dataItem)}}</span>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column *ngIf="viewExtensionsShowAlternateValue" field="alternateValue" [width]="40"
                title="{{ 'ALTERNATE-VALUE' | translate }}">
              </kendo-grid-column>
              <kendo-grid-column *ngIf="viewExtensionsShowDisplayName" field="displayName" [width]="65"
                title="{{ 'DISPLAY-NAME' | translate }}">
              </kendo-grid-column>
              <kendo-grid-command-column [width]="20" title="{{ 'ACTIONS' | translate }}" class="text-center"
                *ngIf="caseExtensionsEditable">
                <ng-template kendoGridCellTemplate let-dataItem let-isNew="isNew">
                  <ng-container *ngIf="!dataItem.editing">
                    <i class="fas fa-edit fa-lg" title="{{'EDIT' | translate}}"
                      (click)="caseExtensionEditButton.click.emit($event); dataItem.editing = true;"></i>
                    &nbsp;
                    <i class="fas fa-trash-alt fa-lg" title="{{'DELETE' | translate}}"
                      (click)="openDeleteCaseExtensionDialog(dataItem)"></i>
                    <button kendoGridEditCommand #caseExtensionEditButton class="d-none"></button>
                  </ng-container>
                  <ng-container *ngIf="dataItem.editing">
                    <ng-container *ngIf="caseExtensionFormGroup.valid">
                      <i class="fas fa-check fa-lg icon-success pointer" title="{{'SAVE' | translate}}"
                        (click)="caseExtensionSaveButton.click.emit($event); dataItem.editing = false;">
                      </i>
                      &nbsp;
                    </ng-container>
                    <i class="fas fa-times-circle fa-lg icon-neutral pointer" title="{{'CANCEL' | translate}}"
                      (click)="caseExtensionCancelButton.click.emit($event); dataItem.editing = false;"></i>
                    <button kendoGridSaveCommand #caseExtensionSaveButton class="d-none"></button>
                    <button kendoGridCancelCommand #caseExtensionCancelButton class="d-none"></button>
                  </ng-container>
                </ng-template>
              </kendo-grid-command-column>
              <button kendoGridAddCommand #caseExtensionAddButton class="d-none"></button>
            </kendo-grid>
            <button kendoButton *ngIf="caseExtensionsEditable" type="button" class="float-right mt-3 mb-3"
              (click)="caseExtensionAddButton.click.emit($event)">
              {{'ADD' | translate}}<i class="far fa-plus"></i>
            </button>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
      <!--Billable Items-->
      <kendo-tabstrip-tab title="{{'BILLABLES' | translate}}"
        *ngIf="revenueManagerEnabled && (isOperatorRole || billablesExist)">
        <ng-template kendoTabContent>
          <div class="content-background pl-3 pr-3 pt-2">
            <div class="row">
              <div class="col-sm-12">
                <div class="inputWithIcon inputWithIcon-search float-right d-flex mb-2">
                  <app-advanced-mode id="accumulatorGridAdvancedSwitch" [storageKey]="'billables-list'"
                    (collapsibleToggle)="enableAdvanced=$event">
                  </app-advanced-mode>
                </div>
              </div>
            </div>
            <kendo-grid [data]="viewBillableItems.gridData" [loading]="viewBillableItems.loading" [navigable]="true"
              [pageable]="billablesCount > viewBillableItems.state.take ? { buttonCount: 5, pageSizes: pageSizes} : false"
              [pageSize]="viewBillableItems.state.take" [skip]="viewBillableItems.state.skip" [sortable]="true"
              [sort]="viewBillableItems.state.sort" [filterable]="enableAdvanced"
              [filter]="viewBillableItems.state.filter" [groupable]="false" [selectable]="{mode: 'single'}"
              [columnMenu]="enableAdvanced" [resizable]="true" [reorderable]="enableAdvanced" [kendoGridSelectBy]="'id'"
              (columnReorder)="onReorder($event)" (columnResize)="onResize($event)"
              (columnVisibilityChange)="onVisibilityChange($event)" (edit)="caseBillableEditHandler($event)"
              (save)="saveCaseBillable($event)" (cancel)="caseBillableCancelHandler($event)"
              (dataStateChange)="billableItemsDataStateChange($event)">
              <kendo-grid-messages noRecords="{{ 'NO-BILLABLES' | translate }}">
              </kendo-grid-messages>
              <ng-template kendoGridToolbarTemplate [position]="'top'" *ngIf="enableAdvanced">
                <button kendoButton (click)="resetGridColumns()" class="float-right">
                  {{'RESET-GRID-COLUMNS' | translate }}
                </button>
              </ng-template>
              <ng-container *ngFor="let col of viewBillableItems.columnsConfig">
                @if (col.field === 'remarkCode') {
                <!--Remark-->
                <kendo-grid-column-group title="{{ 'REMARK' | translate }}">
                  <!--Remark Code-->
                  <kendo-grid-column field="remarkCode" title="{{'CODE' | translate }}" [width]="col.width"
                    [filter]="col.filter" [format]="col.format"
                    [filterable]="col.filterable !== undefined ? col.filterable : true"
                    [hidden]="col.hidden !== undefined ? col.hidden : false" [editable]="false"
                    [class]="col.class ? col.class : ''">
                  </kendo-grid-column>
                  <!--Remark Description-->
                  <kendo-grid-column field="remarkDescription" title="{{'DESCRIPTION' | translate }}"
                    [width]="col.width" [filter]="col.filter" [format]="col.format"
                    [filterable]="col.filterable !== undefined ? col.filterable : true"
                    [hidden]="col.hidden !== undefined ? col.hidden : false" [editable]="false"
                    [class]="col.class ? col.class : ''">
                  </kendo-grid-column>
                  <ng-template kendoGridCellTemplate let-dataItem>
                    <span *ngIf="dataItem.remarkCode">{{ dataItem.remarkCode }}</span>
                    <p *ngIf="dataItem.remarkDescription">{{ dataItem.remarkDescription }}</p>
                  </ng-template>
                </kendo-grid-column-group>
                }
                @else if (col.field !== 'remarkDescription') {
                <kendo-grid-column [field]="col.field" [title]="col.title" [width]="col.width" [filter]="col.filter"
                  [editor]="col.editor" [format]="col.format"
                  [filterable]="col.filterable !== undefined ? col.filterable : true"
                  [hidden]="col.hidden !== undefined ? col.hidden : false"
                  [editable]="col.field === 'id' ? false : true"
                  [class]="col.filter === 'boolean' ? 'text-center' : (col.class ? col.class : '')">
                  <!--Billable name + ad hoc info-->
                  <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'billableName'">
                    <div class="d-flex align-items-center w-100">
                      <span class="flex-grow-1 mr-2" style="line-height: 1.35">{{ dataItem.billableName }}</span>
                      <div *ngIf="dataItem.adhocBillable" kendoTooltip position="right"
                        class="keyboard-accessible d-flex align-items-center justify-content-center flex-shrink-0"
                        style="width: 1.75rem; height: 1.75rem" tabindex="0" showOn="hover" aria-live="polite"
                        [tooltipTemplate]="billableNameAdHocTooltipTpl">
                        <span class="d-flex align-items-center justify-content-center w-100"
                          [attr.title]="'AD-HOC-BILLABLE' | translate">
                          <i class="fa fa-info-circle pointer" style="color: #337ab7; font-size: 1rem; line-height: 1"
                            [attr.aria-label]="'AD-HOC-BILLABLE' | translate"></i>
                        </span>
                      </div>
                    </div>
                    <ng-template #billableNameAdHocTooltipTpl>
                      <span *ngIf="dataItem.createdOn">
                        {{'CREATED-BY' | translate}}&nbsp;<strong>{{dataItem.createdBy}}</strong>&nbsp;{{'TIMESTAMP-ON'
                        |
                        translate}}&nbsp;<strong>{{intl.formatDate(intl.parseDate(dataItem.createdOn),'g')}}</strong>
                      </span>
                    </ng-template>
                  </ng-template>
                  <!--Date of service-->
                  <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'billableDate'">
                    <div *ngIf="dataItem.billableDate !== null && dataItem.billableDate !== undefined"
                      class="text-center">
                      {{ intl.formatDate(intl.parseDate(dataItem.billableDate), "d") }}
                    </div>
                  </ng-template>
                  <!--Modifiers-->
                  <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'modifierCodes'">
                    <span *ngIf="dataItem.modifierCode">{{dataItem.modifierCode}}</span><span
                      *ngIf="dataItem.modifierCode2"><span
                        *ngIf="dataItem.modifierCode">,&nbsp;</span>{{dataItem.modifierCode2}}</span><span
                      *ngIf="dataItem.modifierCode3"><span
                        *ngIf="dataItem.modifierCode2">,&nbsp;</span>{{dataItem.modifierCode3}}</span>
                  </ng-template>
                  <!--Units-->
                  <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'units'">
                    <span
                      *ngIf="!dataItem.billableServiceHasManualAmount && dataItem.units !== 0">{{dataItem.units}}</span>
                    <span *ngIf="dataItem.billableServiceHasManualAmount">{{dataItem.units}}</span>
                  </ng-template>
                  <ng-template kendoGridEditTemplate let-dataItem="dataItem" *ngIf="col.field === 'units'">
                    <div *ngIf="caseBillableEditDiagnosesOnly">
                      <span
                        *ngIf="!dataItem.billableServiceHasManualAmount && dataItem.units !== 0">{{dataItem.units}}</span>
                      <span *ngIf="dataItem.billableServiceHasManualAmount">{{dataItem.units}}</span>
                    </div>
                    <div [formGroup]="caseBillableFormGroup" *ngIf="!caseBillableEditDiagnosesOnly">
                      <kendo-numerictextbox [format]="'n0'" [decimals]="0" [step]="1" formControlName="units" [min]="1"
                        style="max-width:150px">
                      </kendo-numerictextbox>
                    </div>
                  </ng-template>
                  <ng-template kendoGridFilterCellTemplate let-filter let-column="column" *ngIf="col.field === 'units'">
                    <kendo-grid-numeric-filter-cell [column]="column" [filter]="filter" [spinners]="false">
                    </kendo-grid-numeric-filter-cell>
                  </ng-template>
                  <!--Rate-->
                  <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'rate'">
                    <span *ngIf="!dataItem.billableServiceHasManualAmount">{{dataItem.rate | number : '1.2-2'}}</span>
                    <span *ngIf="dataItem.billableServiceHasManualAmount">{{dataItem.rate | number : '1.2-2'}}</span>
                  </ng-template>
                  <ng-template kendoGridEditTemplate let-dataItem="dataItem" *ngIf="col.field === 'rate'">
                    <div *ngIf="caseBillableEditDiagnosesOnly">
                      <span *ngIf="!dataItem.billableServiceHasManualAmount">{{dataItem.rate | number : '1.2-2'}}</span>
                      <span *ngIf="dataItem.billableServiceHasManualAmount">{{dataItem.rate | number : '1.2-2'}}</span>
                    </div>
                    <div [ngSwitch]="!dataItem.billableServiceHasManualAmount" *ngIf="!caseBillableEditDiagnosesOnly">
                      <div *ngSwitchCase="true" [formGroup]="caseBillableFormGroup">
                        <kendo-numerictextbox [format]="'n2'" formControlName="rate" [min]="0" style="max-width:150px">
                        </kendo-numerictextbox>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template kendoGridFilterCellTemplate let-filter let-column="column" *ngIf="col.field === 'rate'">
                    <kendo-grid-numeric-filter-cell [column]="column" [filter]="filter" [spinners]="false">
                    </kendo-grid-numeric-filter-cell>
                  </ng-template>
                  <!--Amount-->
                  <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'amount'">
                    <span *ngIf="dataItem.billableServiceHasManualAmount">{{dataItem.amount | number : '1.2-2'}}</span>
                    <span *ngIf="!dataItem.billableServiceHasManualAmount">{{dataItem.amount | number : '1.2-2'}}</span>
                  </ng-template>
                  <ng-template kendoGridEditTemplate let-dataItem="dataItem" *ngIf="col.field === 'amount'">
                    <div *ngIf="caseBillableEditDiagnosesOnly">
                      <span *ngIf="dataItem.billableServiceHasManualAmount">{{dataItem.amount | number :
                        '1.2-2'}}</span>
                      <span *ngIf="!dataItem.billableServiceHasManualAmount">{{dataItem.amount | number :
                        '1.2-2'}}</span>
                    </div>
                    <div [ngSwitch]="dataItem.billableServiceHasManualAmount" *ngIf="!caseBillableEditDiagnosesOnly">
                      <div *ngSwitchCase="true" [formGroup]="caseBillableFormGroup">
                        <kendo-numerictextbox [format]="'n2'" formControlName="amount" [min]="0"
                          style="max-width:150px">
                        </kendo-numerictextbox>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template kendoGridFilterCellTemplate let-filter let-column="column"
                    *ngIf="col.field === 'amount'">
                    <kendo-grid-numeric-filter-cell [column]="column" [filter]="filter" [spinners]="false">
                    </kendo-grid-numeric-filter-cell>
                  </ng-template>
                  <!--Status-->
                  <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'caseBillableStatus'">
                    <div class="text-center">
                      {{getCaseBillableText(dataItem.caseBillableStatus)}}
                    </div>
                  </ng-template>
                  <!--Org Payment Status-->
                  <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'orgPaymentStatus.displayName'">
                    <div class="text-center">
                      {{dataItem.orgPaymentStatus.displayName}}
                    </div>
                  </ng-template>
                </kendo-grid-column>
                }
              </ng-container>
              <kendo-grid-command-column [width]="30" title="{{ 'ACTIONS' | translate }}" class="text-center"
                *ngIf="isOperatorRole">
                <ng-template kendoGridCellTemplate let-dataItem let-isNew="isNew">
                  <ng-container *ngIf="!dataItem.editing">
                    <i class="fas fa-edit fa-lg pointer"
                      *ngIf="(!dataItem.caseBillableUsedInInvoice || dataItem.caseBillableUsedInErrorInvoice) && !dataItem.billableServiceInformationalOnly"
                      title="{{'EDIT' | translate}}"
                      (click)="caseBillableEditButton.click.emit($event); dataItem.editing = true; adjustmentStatus = -1"></i>
                    &nbsp;
                    <i class="fas fa-layer-plus fa-lg pointer" style="color:#bc7410"
                      *ngIf="dataItem.caseBillableUsedInInvoice && dataItem.caseBillableStatus === 'PAID' && !dataItem.alreadyAdjustedOrVoided"
                      title="{{'ADD-ADJUSTMENT' | translate}}"
                      (click)="caseBillableEditButton.click.emit($event); dataItem.editing = true; adjustmentStatus = 0"></i>
                    &nbsp;
                    <i class="fas fa-layer-minus fa-lg pointer" style="color:#bc7410"
                      *ngIf="dataItem.caseBillableUsedInInvoice && dataItem.caseBillableStatus === 'PAID' && !dataItem.alreadyAdjustedOrVoided"
                      title="{{'ADD-VOID' | translate}}" (click)="openVoidCaseBillableDialog(dataItem)"></i>
                    &nbsp;
                    <i class="fas fa-trash-alt fa-lg pointer"
                      [ngClass]="{'extra-spacing': dataItem.billableServiceInformationalOnly}"
                      *ngIf="!dataItem.caseBillableUsedInInvoice" title="{{'DELETE' | translate}}"
                      (click)="openDeleteCaseBillableDialog(dataItem)"></i>
                    <button kendoGridEditCommand #caseBillableEditButton class="d-none"></button>
                  </ng-container>
                  <ng-container *ngIf="dataItem.editing">
                    <ng-container *ngIf="caseBillableFormGroup.valid && adjustmentChangesMade">
                      <i class="fas fa-check fa-lg icon-success pointer" title="{{'SAVE' | translate}}"
                        (click)="caseBillableSaveButton.click.emit($event);">
                      </i>
                      &nbsp;
                    </ng-container>
                    <i class="fas fa-times-circle fa-lg icon-neutral pointer" title="{{'CANCEL' | translate}}"
                      (click)="caseBillableCancelButton.click.emit($event); dataItem.editing = false;"></i>
                    <button kendoGridSaveCommand #caseBillableSaveButton class="d-none"></button>
                    <button kendoGridCancelCommand #caseBillableCancelButton class="d-none"></button>
                  </ng-container>
                </ng-template>
              </kendo-grid-command-column>
              <ng-template *ngIf="visibleBillableColumn" kendoGridDetailTemplate let-dataItem
                [kendoGridDetailTemplateShowIf]="showDetailsOnlyIfCaseAccessible">
                <app-case-detail-billable [memberId]="memberId" [caseBillableId]="dataItem.id">
                </app-case-detail-billable>
              </ng-template>
            </kendo-grid>
            <button kendoButton *ngIf="isOperatorRole" type="button" class="float-right mt-3 mb-3"
              (click)="createCaseBillable()">
              {{'ADD' | translate}}<i class="far fa-plus"></i>
            </button>
          </div>
        </ng-template>
      </kendo-tabstrip-tab>
    </kendo-tabstrip>
  </kendo-splitter-pane>
  <kendo-splitter-pane
    *ngIf="!isBillablesTabSelected && (caseHistoryEnabled || caseCareTeamsEnabled || patientCareTeamsEnabled || (communityEnabled && pinnedResourcesEnabled))"
    [(size)]="rightPaneSize" [collapsible]="true" min="420px" [resizable]="true" class="pt-0"
    [ngClass]="{'content-background ': !paneCollapsed }" (collapsedChange)="collapseChange($event)">
    <!-- Case History-->
    <div *ngIf="caseHistoryEnabled">
      <hr>
      <h6 class="text-uppercase collapsible-text" (click)="caseHistoriesCollapsible.toggleChange()">{{'CASE-HISTORY' |
        translate}}
        <app-collapsible #caseHistoriesCollapsible [storageKey]="'case-histories'"
          (collapsibleToggle)="caseHistoriesCollapsed=$event">
        </app-collapsible>
      </h6>
      <div *ngIf="!caseHistoriesCollapsed" style="max-height: 400px; overflow-y: auto; overflow-x: hidden;">
        <app-case-history [entries]=displayedHistoryEvents></app-case-history>
      </div>
    </div>
    <!-- Team -->
    <div class="mt-4" *ngIf="caseCareTeamsEnabled">
      <app-team-list *ngIf="member && !switchingCaseContext" [caseId]="id" [memberId]="member.id"
        (assigned)="getCaseDetailsData()" (addTask)="caseDetailSummary.createTask($event)"
        (modifyTeam)="caseDetailSummary.updateTasks($event)">
      </app-team-list>
    </div>
    <div class="mt-4" *ngIf="patientCareTeamsEnabled">
      <div>
        <app-team-list *ngIf="member" [caseId]="" [memberId]="member.id"
          (addTask)="caseDetailSummary.createTask($event)">
        </app-team-list>
      </div>
    </div>
    <!--Goals-->
    <div class="mt-4" *ngIf="goalsEnabled">
      <div>
        <app-goal-list [caseId]="id"></app-goal-list>
      </div>
    </div>
    <!--Pinned Resources-->
    <div class="mt-4" *ngIf="communityEnabled && pinnedResourcesEnabled && memberId && memberId > 0">
      <hr>
      <h6 class="text-uppercase collapsible-text" (click)="pinnedResourcesCollapsible.toggleChange()">{{
        'PINNED-RESOURCES' | translate}}&nbsp;
        <app-collapsible #pinnedResourcesCollapsible [storageKey]="'case-pinned-resources'"
          (collapsibleToggle)="patientPinnedResourcesCollapsed=$event">
        </app-collapsible>
      </h6>
      <div *ngIf="!patientPinnedResourcesCollapsed">
        <app-pinned-resource-list [memberId]="memberId"></app-pinned-resource-list>
      </div>
    </div>
  </kendo-splitter-pane>
</kendo-splitter>

<!-- delete case extension confirmation dialog -->
<kendo-dialog *ngIf="caseExtensionDeleteDialogOpened" title="{{'PLEASE-CONFIRM' | translate}}" [width]="400"
  (close)="caseExtensionDeleteDialogOpened = false">
  <p>{{'CONFIRM-CASE-EXTENSION-DELETION' | translate}}</p>
  <div>
    <span
      class="k-font-weight-bold">{{selectedCaseExtension.settingExtension.organization.name}}&nbsp;-&nbsp;{{selectedCaseExtension.settingExtension.name}}</span>
  </div>
  <kendo-dialog-actions>
    <button kendoButton (click)="caseExtensionDeleteDialogOpened = false">{{'NO' | translate}}</button>
    <button kendoButton (click)="deleteCaseExtension(selectedCaseExtension)" [disabled]="errorMessage">{{'YES' |
      translate}}</button>
  </kendo-dialog-actions>
</kendo-dialog>

<!-- delete case billable confirmation dialog -->
<kendo-dialog *ngIf="caseBillableDeleteDialogOpened" title="{{'PLEASE-CONFIRM' | translate}}" [width]="400"
  (close)="caseBillableDeleteDialogOpened = false">
  <p>{{'CONFIRM-CASE-BILLABLE-DELETION' | translate}}</p>
  <div>
    <span
      class="k-font-weight-bold">{{selectedCaseBillable.billableName}}&nbsp;-&nbsp;{{getCaseBillableText(selectedCaseBillable.caseBillableStatus)}}</span>
  </div>
  <kendo-dialog-actions>
    <button kendoButton (click)="caseBillableDeleteDialogOpened = false">{{'NO' | translate}}</button>
    <button kendoButton (click)="deleteCaseBillable(selectedCaseBillable)" [disabled]="errorMessage">{{'YES' |
      translate}}</button>
  </kendo-dialog-actions>
</kendo-dialog>

<!-- Add Adjustment case billable confirmation dialog -->
<kendo-dialog *ngIf="caseBillableAdjustmentVoidDialogOpened" title="{{'PLEASE-CONFIRM' | translate}}" [width]="500"
  (close)="caseBillableAdjustmentVoidDialogOpened = false">
  <p *ngIf="adjustmentStatus === 0">{{'CONFIRM-CASE-BILLABLE-ADJUSTMENT' | translate}}</p>
  <p *ngIf="adjustmentStatus === 1">{{'CONFIRM-CASE-BILLABLE-VOID' | translate}}</p>
  <div>
    <span
      class="k-font-weight-bold">{{selectedCaseBillable.billableName}}&nbsp;-&nbsp;{{getCaseBillableText(selectedCaseBillable.caseBillableStatus)}}</span>
  </div>
  <div class="p-2">
    <div class="form-group pl-1 pr-1" style="max-height:265px;overflow-y:auto;overflow-x:hidden;">
      <label class="k-text-uppercase dark mb-0">{{'ADJUSTMENT-DATE' |
        translate}} * </label>
      <div class="mb-2">
        <div class="row">
          <div class="col-5">
            <kendo-datepicker required [min]="minDateOfAdjustment" [max]="maxDateOfAdjustment"
              [(ngModel)]="dateOfAdjustment">
            </kendo-datepicker>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group pl-1 pr-1 mb-0">
      <label for="adjustmentReason" class="k-text-uppercase dark w-100">{{'ADJUSTMENT-REASON' | translate}} *
        <textarea id="adjustmentReason" required class="w-100" kendoTextArea rows="3" [(ngModel)]="reason"
          style="max-height: 400px;" maxlength="4000">
      </textarea>
      </label>
    </div>
  </div>
  <div>* {{'REQUIRED-FIELDS' | translate}}</div>
  <kendo-dialog-actions>
    <button kendoButton type="button" (click)="cancelBillableAdjustment()">{{ 'CANCEL' | translate }}</button>
    <button appPreventClick kendoButton type="button" (click)="adjustBillable()"
      [disabled]="dateOfAdjustment === null || reason === null || reason.trim().length === 0">{{'SAVE' | translate}}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<!--Billable Add/Edit modal-->
<app-case-detail-add-billable *ngIf="addDialogOpened" [caseId]="id" [memberId]="memberId"
  (added)="onCaseBillableAdded()" (cancelled)="onCaseBillableCancelled()">
</app-case-detail-add-billable>